import React, { useState } from 'react';
import * as Yup from 'yup';
import { FormHandles } from '@unform/core';
import uuid from '../../UniqueHash';
import { useModal } from '../../../../../../hooks/Modal';
import FormComponent, { sanitizeDataObject } from '../../FormComponent';
import { createSchemaByForm, IYup } from '../../../../../../utils/SchemaCreator';
import getValidationErrors from '../../../../../../utils/getValidationErrors';
import api from '../../../../../../services/api';
import { useToast } from '../../../../../../hooks/Toast';
import { useSearch } from '../../../../../../hooks/Search';
import { AxiosInstance } from 'axios';
import { FaChartBar, FaEdit, FaEye } from 'react-icons/fa';
import { Field } from '../../../../../../components/QuizzComponent/styles';
import CheckboxInput from '../../Forms/CheckboxInput';
import { Form } from '@unform/web';

interface ICreateModule {
  lineData: Record<string, any>;
  title: string;
  formSchema: Record<string, any>;
  endpoint: string;
  validationSchema: Record<string, IYup>;
  apiRef ?: AxiosInstance,
}

interface IQuestion {
  id : string;
  label : string;
  value: string;
}

export default function QuizzChartModule({
  apiRef = api,
  lineData,
  title,
  formSchema,
  validationSchema,
  endpoint,
}: ICreateModule): JSX.Element {
  const { reloadSearchAll } = useSearch();
  const { addModal, removeModal } = useModal();
  const { addToast } = useToast();

  let selectedOptionVote = '';
  const key = uuid();

  const readReport = report => {
    console.log(report);
    const counter = report.report.reduce((prev, con) => {
      prev += con.count;

      return prev;
    }, 0);

    return (
      <>
        <p style={{color: '#333'}}>Pergunta</p>
        <h2 style={{color: '#333'}}>{report.title}</h2>
        <Field>
          <div className="voteOption">
            <button
              className="defaultButtonMini"
              style={{ marginRight: '5px', padding:'3px', width: 'auto', minWidth:'100px' }}
              type="button"
            >
              {report.users}
            </button>
{' '}
            <span style={{color: '#333'}}>Usuários participaram</span>
          </div>
        </Field>
        <p>Resultados</p>
        {report.report.map(quest => {
          const percentage = (quest.count / counter) * 100 || 0;
          return (
            <Field>
              <div className="voteOption">
                <button
                  className="defaultButtonMini"
                  style={{ marginRight: '5px', padding:'3px', width: 'auto', minWidth:'100px' }}
                  type="button"
                >
                  {percentage.toFixed(2)} %
                </button>
{' '}
                <span style={{color: '#333'}}>{quest.title}</span>
              </div>
            </Field>
          );
        })}
      </>
    );
  };

  const getReport = async ({id}) => {
  
    const response = await api.get(`/quizz_answer_report/${id}`);
    if (response.status !== 200) {
      return addToast({ type: 'error', title: 'Erro ao recuperar resultados' });
    }


     
    const content =   readReport(response?.data);
    
    const keyModal = addModal({ title, content, key: 'votacao',theme : "whiteModal" });
  };



  const moduleUpdate = (lineData): JSX.Element => (
    <button
    title="Visualizar Pergunta"
    onClick={() => getReport(lineData)}
    type="button"
    className="defaultButtonMini"
  >
    <FaChartBar />
  </button>
  );

  return moduleUpdate(lineData);
}
